angular.module('dealerware.web.data').factory('DealerwareUserModel', function ($http,Model,$q,DataUtils) {

    var model = new Model({
        baseEndpoint: '/locations/:location_id/users',
        rootNode: 'user',
        customActions: {
            getCurrentUser: {
                method: 'GET',
                endpoint: '/locations/:location_id/users/:id',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            getRoles: {
                method: 'GET',
                endpoint: '/locations/:location_id/users/roles',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            login: {
                method: 'POST',
                endpoint: '/sessions',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            logout: {
                method: 'DELETE',
                endpoint: '/sessions'
            },
            clearActivationRequired: {
                method: 'PUT',
                endpoint: '/locations/:location_id/users/:id/clear_activation_required',
                ignoreDefaultRootNode: true,
                ignoreAssociations: true
            },
            forgotPassword: {
                method: 'POST',
                endpoint: '/users/emails/forgot_password',
                ignoreDefaultRootNode: true,
                ignoreAssociations: true
            },
            // I don't think this is used.
            //
            index: {
                method: 'GET',
                endpoint: '/locations/:location_id/users/search',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            }
        },

        responseTransforms: {
            getCurrentUser: mapUserProfileResults,
            login: mapUserProfileResults
        }
    });

    function mapUserProfileResults (args, data) {
        data.user_profile_attributes = angular.copy(data.user_profile);
        delete data.user_profile;
    }

    jQuery.extend(model.prototype,{
        getUserFullName: function() {
            return (this.hasOwnProperty('data') && angular.isObject(this.data) && this.data.hasOwnProperty('user_profile_attributes') && angular.isObject(this.data.user_profile_attributes) && this.data.user_profile_attributes.hasOwnProperty('full_name')) ? this.data.user_profile_attributes.full_name : undefined;
        },
        hasRole: function(role){
            var hasRole = false;
            if (role && isArray(role)) {
                var self = this;
                $.each(role,function(idx,val){
                    hasRole = self.inRole(val);
                    if (hasRole) {
                        return false;
                    }
                });
            }
            else {
                hasRole = this.inRole(role);
            }
            return hasRole;
        },
        inRole: function(role) {
            var inRole = false;
            var _self = this;
            if (this.data.roles_mapped && isArray(this.data.roles_mapped)) {
                $.each(this.data.roles_mapped,function(idx,val){
                    if ( val.name == 'superuser1' || val.name == role ) {
                        inRole = true;
                        return false;
                    }
                });
            }
            return inRole;
        },
        needsCompanyActivation: function() {
            return (this.data.company_activation_required);
        }
    });

    return model;
})
.config(function($provide) {
    $provide.decorator('UserModel', function($delegate,$injector) {
        return $injector.get("DealerwareUserModel");
    });
});
